export enum IconTypeEnum {
  TASK_TYPE = "TaskType",
  TASK_PRIORITY = "TaskPriority",
}
